<template>
  <div>
    <div>
      <select :class='selectClass' v-model="selected" v-bind:value="value" @input="$emit('input', $event.target.value)">
        <template v-if="placeholderText">
          <option :class='selectClass' value="" disabled selected>{{placeholderText}}</option>
        </template>
        <option :class='selectClass' v-for="(option) in options" v-bind:value="option[selectValue]" :key="option[selectValue]">
            {{ option.name }}
        </option>
      </select>
    </div>
</div>
</template>
<script>
export default {
  props: {
    options: {
      type: Array
    },
    value: {
      type: [String, Number],
      default: ''
    },
    defaultValue: {
      type: String,
      default: ''
    },
    selectValue: {
      type: String,
      default: 'value'
    },
    placeholderText: {
      type: [String, Boolean],
      default: false
    },
    selectClass: {
      type: String,
      default: 'select--border'
    }
  },
  data () {
    return {

    }
  },
  computed: {
    selected: {
      get () {
        if (this.value === '' && this.defaultValue) {
          return this.defaultValue
        } else {
          return this.value
        }
      },
      set (value) {
      }
    }
  },
  methods: {
  }
}
</script>
